/**
 * BST Product Specifications — reveal rows after summary limit
 */
(function () {
  'use strict';

  function expandTable(table) {
    const toggleWrap = table.querySelector('[data-bst-specs-toggle-wrap]');
    const hiddenBlock = table.querySelector('[data-bst-specs-hidden]');

    if (!hiddenBlock) return;

    hiddenBlock.hidden = false;

    if (toggleWrap) {
      toggleWrap.hidden = true;
    }
  }

  function initTable(table) {
    if (table._bstSpecsInit) return;
    table._bstSpecsInit = true;

    const toggle = table.querySelector('[data-bst-specs-toggle]');
    const hiddenBlock = table.querySelector('[data-bst-specs-hidden]');

    if (!toggle || !hiddenBlock) return;

    toggle.addEventListener('click', (event) => {
      event.preventDefault();
      expandTable(table);
    });
  }

  function init() {
    document.querySelectorAll('[data-bst-specs-table]').forEach(initTable);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
